import { type ReactNode, type RefObject, useEffect, useRef } from "react";
import { Lane } from "./lane";

/**
 * The lane as an element: React draws the box, the `Lane` draws the floats
 * inside it, so a burst never re-renders the page.
 */
export function FloatLane({
  lane,
  cap,
  className,
}: {
  lane: RefObject<Lane | null>;
  cap: number;
  className: string;
}): ReactNode {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = box.current;
    if (!el) return;
    const drawn = new Lane(el, cap);
    lane.current = drawn;
    return () => {
      drawn.clear();
      if (lane.current === drawn) lane.current = null;
    };
  }, [lane, cap]);
  return <div ref={box} className={className} aria-hidden="true" />;
}
